import {Component, OnInit} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {Router} from "@angular/router";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs";
import {BackupStatus} from "./backup.data";

@Component({
    selector: "fhm-backup-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./backup-page.component.html",
    standalone: false
})
export class BackupPageComponent implements OnInit {

    backupStatus: BackupStatus;


    constructor(
        private http: HttpClient,
        private auth: AuthApiService,
        private errorHandler: ErrorHandlerService,
        private spinnersService: FUISpinnersService,
        private router: Router) {
    }

    ngOnInit(): void {
        this.http.get("/fonzie/backup-status", {
            headers: this.auth.getHttpHeaderOptions()
        })
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe((data: BackupStatus) => {
                this.backupStatus = data;
            });
    }

    done(): void {
        this.router.navigate(["/main/customer-instance-venue-search"]);
    }


    backup(): void {
        this.spinnersService.open();
        this.http.post("/fonzie/backup", {}, {
            headers: this.auth.getHttpHeaderOptions()
        })
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe((data: BackupStatus) => {
                this.backupStatus = data;
                this.spinnersService.close();
            });
    }

}
